<mat-card class="s-card-container">
  <div class="s-card-header" [attr.data-bg]="shareeCardBg">
    <mat-card-header>
      <div mat-card-avatar class="s-card-avatar">
        <span *ngIf="!donor?.donoravtar">{{donor?.initials | uppercase}}</span>
        <img #profileSrc class="sc-img" [hidden]="!donor?.donoravtar" [src]="donor?.donoravtar?.cdn_path" [alt]="'Donor - '+donor?.name" />
      </div>
      <mat-card-title *ngIf="cardType=='donor'" class="s-card-title"> <span class="text-capitalize">{{donor?.name}}</span>, you have supported this fundraiser</mat-card-title>
      <mat-card-title *ngIf="cardType=='sharee'" class="s-card-title">
          Your friend <span class="text-capitalize">{{donor?.name}}</span> has supported this fundraiser
      </mat-card-title>
      <button class="more-dots" *ngIf="cardType=='donor' && isLoggedIn" type="button" [matMenuTriggerFor]="menu" mat-icon-button><mat-icon>more_vert</mat-icon></button>
    </mat-card-header>
    <span *ngIf="status==1" class="s-card-anonymous">Your name/picture is only displayed to you</span>
  </div>
  <mat-card-content class="s-card-content">
    <div class="s-card-donation-container" *ngFor="let donataion of donations">
      <div class="s-card-donation">
        <div class="sc-amount">
          Donated <app-currency-icon [currency]="donataion?.iso_currency"></app-currency-icon> {{donataion?.donated_amount_local}}
        </div>
        <div *ngIf="donataion?.activation?.creation_date" class="sc-date">{{donataion.activation.creation_date | dayjs:'format':'MMM D, YYYY'}}</div>
      </div>
      <div *ngIf="donataion?.comments[0]?.text" class="s-card-comment">“{{donataion.comments[0]?.text}}”</div>
    </div>
  </mat-card-content>
  <div class="share-actions">
    <app-fb-share class="sc-fb-share" [label]="'Stories.updates.spreadtheWord' | translatePipe | async" [fundraiser]="fundraiser"></app-fb-share>
  </div>
</mat-card>
<!-- File Upload Input -->
<input #profilePic type="file" style="display: none" (change)="changeProfilePic($event)">
<!-- Support card menu options -->
<mat-menu class="sc-donor-menu" #menu="matMenu">
  <button *ngIf="donations && donations.length<2" class="menu-item" mat-menu-item (click)="updateAnonymousStatus()">
    {{status==1?'Show my name for this donation':'Make my donation anonymous'}}
  </button>
  <button class="menu-item" mat-menu-item (click)="profilePicOnCick()">Change Picture</button>
</mat-menu>
